import { render, staticRenderFns } from "./SmartConfig.vue?vue&type=template&id=267771bb&scoped=true"
import script from "./SmartConfig.vue?vue&type=script&lang=js"
export * from "./SmartConfig.vue?vue&type=script&lang=js"
import style0 from "./SmartConfig.vue?vue&type=style&index=0&id=267771bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267771bb",
  null
  
)

export default component.exports